<template>
  <div class="icon-wrapper no-print" :class="type" v-if="(!icon.hideStory && this.$isEngCom) || this.$isProjects">
    <div class="icon" :class="{hover}" @mouseover="hover = true" @mouseout="hover = false" @click.stop="click">
      <img v-if="icon.image" :src="icon.image"/>
      <i v-if="icon.class" :class="icon.class"></i>
    </div>
    <div class="text" :class="{hover}" @mouseover="hover = true" @mouseout="hover = false" @click.stop="click">
      <span class="is-hidden-mobile is-hidden-tablet-only">{{ $t(icon.text) }}</span>
      <span class="is-hidden-desktop">{{ $t(icon.mobile) }}</span>
    </div>
  </div>
</template>

<script>

const icons = {
  post: { image: '/static/icons/annotate-post.svg', text: 'projectPage.remixAsNewSection', mobile: 'projectPage.section', annotate: true, hideStory: true },
  edit: { text: 'projectPage.edit', mobile: 'projectPage.edit', annotate: true, class: 'fal fa-pencil-alt' },
  expand: { class: 'fal fa-expand-arrows-alt', text: 'projectPage.expand', mobile: 'projectPage.expand', preview: true },
  deleting: { text: 'projectPage.remove', mobile: 'projectPage.remove', annotate: true, class: 'fal fa-trash-alt' },
  comment: { image: '/static/icons/annotate-comment.svg', text: 'projectPage.remixAsReply', mobile: 'projectPage.reply', annotate: true }
}

export default {
  props: ['type'],

  data: function () {
    return {
      hover: false
    }
  },

  computed: {
    icon: function () {
      return icons[this.type] || {}
    }
  },

  methods: {
    click: function () {
      if (this.type === 'post' || this.type === 'comment') {
        this.$emit('annotate', this.type)
      } else {
        this.$emit(this.type)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.icon-wrapper {
  color: white;
  z-index: 3;

  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin: 0 10px;

  .icon {
    background: #000;
    border-radius: 100px;
    opacity: 0.75;
    width: 2.5rem;
    height: 2.5rem;
    padding: 0.1rem;

    img{
      height: auto;
      color: #fff;
      height: 1.8rem;
    }

    &.hover {
      background: $primary;
    }
  }

  .text {
    padding-left: 0.5rem;
    font-size: 0.75rem;
  }

  &.comment {
    .icon {
      padding: 0.25rem;
    }
  }
}
</style>
